import { render, staticRenderFns } from "./checkout-bill-to-pax.vue?vue&type=template&id=b6ef2fae&"
import script from "./checkout-bill-to-pax.vue?vue&type=script&lang=js&"
export * from "./checkout-bill-to-pax.vue?vue&type=script&lang=js&"
import style0 from "./checkout-bill-to-pax.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports